export default function (name: string) {
  const cookie = useCookie<string | undefined>(name);
  cookie.value = undefined;
}
